<div>
    <button *ngIf="item.type === 'submenu'" 
            (click)="toggleSubMenu()"
            class="white-button"
            [ngClass]="{'unselected-button': !item.active, 'selected-button': item.active}"
            [disabled]="item.disabled">
        <app-menu-section-button [item]="item"></app-menu-section-button>
    </button>
    <button *ngIf="item.type === 'action'"
            (click)="item.action()"
            class="white-button"
            [ngClass]="{'unselected-button': !item.active, 'selected-button': item.active}"
            [disabled]="item.disabled">
        <app-menu-section-button [item]="item"></app-menu-section-button>
    </button>
    <button *ngIf="item.type === 'url'"
            [routerLink]="item.url"
            class="white-button"
            [ngClass]="{'unselected-button': !item.active, 'selected-button': item.active}"
            [disabled]="item.disabled">
        <app-menu-section-button [item]="item"></app-menu-section-button>
    </button>
</div>

<div *ngIf="item.submenuShow" class="submenu">
    <ng-container *ngFor="let s of item.submenuItems">
        <button class="sub-button" 
                *ngIf="s.type === 'url'"
                [routerLink]="s.url" 
                matBadge="!"
                [matBadgeHidden]="!s.showBadge"
                matBadgeSize="small"
                matBadgePosition="before">
            <span class="sub-button-text">{{s.text}}</span>
        </button>
        <button class="sub-button" 
                *ngIf="s.type === 'action'"
                (click)="s.action()" 
                matBadge="!"
                [matBadgeHidden]="!s.showBadge"
                matBadgeSize="small"
                matBadgePosition="before">
            <span class="sub-button-text">{{s.text}}</span>
        </button>
    </ng-container>
    
</div>